import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export type Axis = 'X' | 'Y' | 'Z' | 'E';

export class AxisControlCommand extends AbstractCommand {
  public readonly category = 'print';
  public readonly command = 'gcode_line' as const;

  private static readonly DEFAULT_XY_SPEED = 3000;
  private static readonly DEFAULT_ZE_SPEED = 900;

  constructor(
    private axis: Axis,
    private distance: number,
    private unit: number = 1.0,
    private speed?: number
  ) {
    super({
      axis_control: axis
    });

    // Set default speeds if not provided
    if (!speed) {
      this.speed = (axis === 'X' || axis === 'Y') 
        ? AxisControlCommand.DEFAULT_XY_SPEED 
        : AxisControlCommand.DEFAULT_ZE_SPEED;
    }
  }

  toJSON(): object {
    const value = this.distance * this.unit;
    const gcode = this.buildGCode(value);

    return {
      print: {
        command: 'gcode_line',
        sequence_id: getSequenceId().toString(),
        gcode
      }
    };
  }

  private buildGCode(value: number): string {
    if (this.axis === 'E') {
      return `M83\nG0 ${this.axis}${value.toFixed(1)} F${this.speed}`;
    }

    return `M211 S\nM211 X1 Y1 Z1\nM1002 push_ref_mode\nG91\nG1 ${this.axis}${value.toFixed(1)} F${this.speed}\nM1002 pop_ref_mode\nM211 R`;
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('print' in response)) {
      return false;
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } };
    const responseId = printResponse.print?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}